var app = angular.module("leonardo");

var SelectAccountDialog = function($scope, $q, AccountService, AccountUserService, PermissionService, AuthService,
                                   $http, ConfigThemeService, AuthDataService) {

  $scope.permission = $scope.ngDialogData ? $scope.ngDialogData.permission : null;
  $scope.exclude = $scope.ngDialogData ? $scope.ngDialogData.exclude : null;
  $scope.workAsUser = $scope.ngDialogData ? $scope.ngDialogData.workAsUser : false;
  $scope.actionName = $scope.ngDialogData ? $scope.ngDialogData.actionName : null;

  $scope.authDataService = AuthDataService;

  $scope.accounts_valid = [];

  $scope.availableAccounts = $scope.ngDialogData ? $scope.ngDialogData.availableAccounts : null;

  var defer = $q.defer();

  $scope.accounts = defer.promise;

  $scope.account = '';

  $scope.init = false;

  if ($scope.workAsUser) {
    var url = ConfigThemeService.generateURL('/api/2.0/accounts/');
    url += '?disable_pagination=true&essential=true';
    var token = 'jwt ' + AuthService.getOldToken();
    $http.get(url, { headers: { 'Authorization': token } }).then(function (data) {
      data = data.data;
      var results = data.results ? data.results : data;
      angular.forEach(results, function (account) {
        if (account.id !== $scope.exclude) {
          $scope.accounts_valid.push(account);
        }
      });
      defer.resolve($scope.accounts_valid);
    });
  }
  else if ((AccountService.getCollection().length > 0) && AuthDataService.isNotStaff()) {
    if ($scope.permission) {
      validAccounts(AccountService.getCollection());
    }
    else {
      $scope.accounts_valid = AccountService.getCollection().filter(function (obj) {
        return ((obj.id !== $scope.exclude) && (!$scope.availableAccounts || _.contains($scope.availableAccounts, obj.id)));
      });
    }
    defer.resolve($scope.accounts_valid);
    $scope.init = false;
  }
  else if (AuthDataService.isNotStaff()) {
    AccountService.getAll({ summary: true }).then(function (data) {
      var results = data.results ? data.results : data;
      if ($scope.permission) {
        validAccounts(results);
      }
      else {
        $scope.accounts_valid = results.filter(function (obj) {
          return ((obj.id !== $scope.exclude) && (!$scope.availableAccounts || _.contains($scope.availableAccounts, obj.id)));
        });
      }
      defer.resolve($scope.accounts_valid);
      $scope.init = false;
    });
  }
  else {
    $scope.accounts_valid = AccountService.getCollection().filter(function (obj) {
      return ((obj.id !== $scope.exclude) && (!$scope.availableAccounts || _.contains($scope.availableAccounts, obj.id)));
    });
    defer.resolve($scope.accounts_valid);
  }

  function validAccounts(results) {
    angular.forEach(results, function (account) {
      if ((account.id !== $scope.exclude) && (!$scope.availableAccounts || _.contains($scope.availableAccounts, account.id))) {
        angular.forEach(AccountUserService.currentAccountUser.permissions, function (permissions) {
          if (account.id === permissions.account) {
            if (permissions[$scope.permission] || PermissionService.isOwner(permissions)) {
              $scope.accounts_valid.push(account);
            }
          }
        });
      }
    });
  }

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) return;
    var account = $scope.account ? $scope.account : 'all';
    $scope.confirm(account);
  };

};

app.controller('SelectAccountDialog', ['$scope', '$q', 'AccountService', 'AccountUserService', 'PermissionService',
  'AuthService', '$http', 'ConfigThemeService', 'AuthDataService', SelectAccountDialog]);
